<template>
  <vs-popup
    :title="'Edit setup: ' + (setup ? setup.name : '')"
    :active.sync="showThisPopup"
    @close="handlePopupClose"
    class="edit-venue-setup-popup"
  >
    <vs-tabs v-if="clonedSetup" value="0">
      <vs-tab label="Setup and policies">
        <vs-row vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              id="edit-setup-name-input"
              label="Name of the setup"
              placeholder="Example: 'Regular week'"
              v-model="clonedSetup.name"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12">
          <vs-col vs-w="12">
            <h6 class="mt-6 mb-4">Setup policies</h6>
            <edit-policies
              v-if="clonedSetup"
              :object-with-policies="clonedSetup"
              :policy-level="POLICY_LEVEL.Setup"
            ></edit-policies>
          </vs-col>
        </vs-row>
      </vs-tab>

      <vs-tab label="Products">
        <vs-row vs-w="12">
          <vs-col vs-w="12">
            <h6 class="mb-4">Current products</h6>
            <edit-product
              :setup="clonedSetup"
              v-model="clonedProducts"
              :is-loading-products="isLoadingProducts"
            ></edit-product>
          </vs-col>
        </vs-row>
      </vs-tab>
    </vs-tabs>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        color="warning"
        type="border"
        class="mr-4"
        v-if="
          hasPermissionForActiveVenue(
            'vp.vp.booking.deletesetup'
          )
        "
        @click="handleDeleteSetup"
        >Delete Setup</vs-button
      >
      <vs-button
        color="primary"
        v-if="
          hasPermissionForActiveVenue(
            'vp.vp.booking.createeditsetup'
          )
        "
        :disabled="!(validForm && isDirty)"
        @click="handleSaveSetupClick"
        >Save Setup</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>
import * as _ from "lodash";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import EditPolicies from "../components/policies/EditPolicies.vue";
import EditProduct from "../components/products/EditProducts.vue";
import { POLICY_LEVEL } from "@/store/modules/marcom/data-model/policy-configurations/index.js";

export default {
  components: { EditPolicies, EditProduct },
  props: {
    setup: {
      type: Object,
    },
  },
  data() {
    return {
      POLICY_LEVEL,
      clonedSetup: undefined,
      showThisPopup: false,
      products: undefined,
      clonedProducts: undefined,
      isLoadingProducts: false,
    };
  },
  computed: {
    validForm() {
      return (
        !!this.clonedSetup &&
        !!this.clonedSetup.name &&
        !!this.clonedSetup.name.trim() &&
        this.policiesValid &&
        this.productsAreValid
      );
    },
    isDirty() {
      return (
        !_.isEqual(this.setup, this.clonedSetup) ||
        !_.isEqual(this.products, this.clonedProducts)
      );
    },
    policiesValid() {
      return (
        !!this.clonedSetup &&
        this.clonedSetup.venuePolicies.every((p) => p.isValid())
      );
    },
    productsAreValid() {
      if (!!this.clonedProducts && this.clonedProducts.length > 0)
        return _.every(this.clonedProducts, (p) => {
          return (
            !!p.name && !!p.image && !!p.unitPrice && !!p.unitPrice.currency
          );
        });
      return true;
    },
  },
  methods: {
    async show() {
      if (!this.clonedSetup) {
        this.clonedSetup = _.cloneDeep(this.setup);

        if (!this.clonedSetup.venuePolicies) {
          this.clonedSetup.venuePolicies = [];
        }
      }

      await this.loadProducts();
      this.clonedProducts = _.cloneDeep(this.products);

      this.showThisPopup = true;
    },
    async loadProducts() {
      this.isLoadingProducts = true;

      var result = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetProductsBySetup,
        this.setup
      );
      this.products = result;

      this.isLoadingProducts = false;
    },
    async handleSaveSetupClick() {
      this.$vs.loading();

      try {
        await this.$store.dispatch("marcom/" + VENUE_ACTIONS.UpdateSetup, {
          venueSetup: this.clonedSetup,
          products: this.clonedProducts,
        });

        this.$vs.notify({
          color: "success",
          title: "Setup saved",
          text: "Your setup was saved",
        });

        this.handlePopupClose();

        this.$emit("setup-saved", this.clonedSetup);
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Setup saved",
          text: "Oops, something went wrong: " + err.title,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async handleDeleteSetup() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Delete setup",
        text: "Would you like to delete the setup: " + this.setup.name + "?",
        acceptText: "Delete setup",
        accept: this.acceptAlertDeleteSetup,
      });
    },
    async acceptAlertDeleteSetup() {
      this.$vs.loading();

      var deleteSetupCommand = {
        setupId: this.clonedSetup.id,
      };

      try {
        var result = await this.$store.dispatch(
          "marcom/" + VENUE_ACTIONS.DeleteSetup,
          deleteSetupCommand
        );

        //Update the client version
        //this.setup.deleted = new Date().toString();
        this.handlePopupClose();

        this.$vs.notify({
          color: "success",
          title: "Setup deleted",
          text: "Your setup was deleted",
        });

        this.$emit("setup-saved", this.clonedSetup);
      } catch (err) {
        this.$vs.dialog({
          color: "danger",
          title: "Setup was not deleted",
          text:
            "There are future bookings for this setup: " +
            (err.details ? err.details : "") +
            (err.title ? err.title : "") +
            ", " +
            (err.detail ? err.detail : ""),
          acceptText: "Ok",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    handlePopupClose() {
      this.clonedSetup = undefined;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-venue-setup-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;

    .vs-tabs--content {

      max-height: calc(100vh - 425px);
      overflow: auto;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
